<template>
  <div
    data-allow-mismatch
    class="fast-page-container tw-min-h-[50vh]"
    :class="[
      shouldFixedTop
        ? '!tw-pt-0'
        : (isHomepage ? 'md:!tw-pt-0 !tw-pt-16' : '!tw-pt-16 md:!tw-pt-20')
    ]"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  isHomepage: boolean
}>()
const themeStyleStore = useThemeStyleStore()
const shouldFixedTop = computed(() => themeStyleStore.themeId === 3)
</script>

<style scoped>
/* Override Quasar's auto-computed padding-bottom for QFooter */
.fast-page-container {
  padding-bottom: 0 !important;
}

/* Remove Quasar's QPage min-height so footer stays right below content */
.fast-page-container :deep(.q-page) {
  min-height: 0 !important;
}
</style>
